import React from 'react';
import {TextField} from "@mui/material";

const DateTime = (props) => {
    return (
        <TextField
            id="time"
            label="Время"
            type="time"
            defaultValue="07:30"
            InputLabelProps={{
                shrink: true,
            }}
            inputProps={{
                step: 300, // 5 min
            }}
            sx={{ width: '100%' }}
            {...props}
        />
    );
};

export default DateTime;